import { useMemo, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { fetchMentions, buildLocalMentionSections } from "../utils";
import { EditorMentionsRoot } from "../embeds/root";
import { User } from "views/settings-users/types";

type UseMentionHandlerArgs = {
  applicationId?: string;
  propertyId?: number;
  propertyName?: string;
  requirePropertyAccess?: boolean;
  hasRelatedObject?: boolean;
  users?: User[];
};

export const useMentionHandler = (args: UseMentionHandlerArgs) => {
  const argsRef = useRef(args);
  argsRef.current = args;
  const queryClient = useQueryClient();

  return useMemo(
    () => ({
      queryClient,
      searchCallback: (query: string) => {
        const {
          applicationId,
          propertyId,
          propertyName,
          requirePropertyAccess,
          hasRelatedObject,
          users
        } = argsRef.current;

        // When `users` is provided, the mention candidate set is restricted to
        // that list (e.g. tasks scope mentions to assignees). The API path is
        // only used for editors that mention from the partner-wide population.
        if (users)
          return Promise.resolve(
            buildLocalMentionSections({
              query,
              users,
              propertyId,
              propertyName,
              requirePropertyAccess,
              hasRelatedObject
            })
          );
        return fetchMentions({
          query,
          applicationId,
          propertyName
        });
      },
      renderComponent: (props) => <EditorMentionsRoot {...props} />
    }),
    []
  );
};
